/**
 * Central API base URL - used everywhere for backend requests.
 * Set NEXT_PUBLIC_API_URL in .env.local to override (e.g. for different environments).
 */
export const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_URL || "http://65.1.116.194:4002";

/** When false, service/menu prices are hidden across the public site and booking UI. */
export const SHOW_SERVICE_PRICING = false;

/** Direct booking external URL for Book Appointment */
export const TIMELY_BOOKING_URL = "https://blosmhairandbeauty.gettimely.com/";

/** Direct booking external URL for Services "Book Now" */
export const SERVICES_BOOK_NOW_URL =
  "https://bookings.gettimely.com/blosmhairandbeauty/book?uri=https%3A%2F%2Fbook.gettimely.com%2FBooking%2FLocation%2F293021%3Fmobile%3DTrue%26locationId%3D378250%26params%3D%25253fchannel%25253dgar%252526client-login%25253dtrue%252526location%25253d378250%252526rwg_token%25253dAE37R_jwQ7SL380JLD7EACYkBF9RBoZNmyCBy353aJlwWg2kf--6QCwTrUsiOy_OfsJ7J2TZMIAQ80R3XK37q64RKIo_L23lJg%25253d%25253d";

